var _rect, _rect2, _circle, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSofaActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 11,
    height: 11,
    rx: 1,
    fill: "#2965FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 12.3187,
    width: 18.9038,
    height: 5.5852,
    rx: 2.7926,
    fill: "#2965FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.94688,
    cy: 9.42626,
    r: 1.64806,
    fill: "#2965FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3287,
    cy: 9.42626,
    r: 1.64806,
    fill: "#2965FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15527 17.0446H7.30343V19.4075C7.30343 20.0007 6.82255 20.4816 6.22935 20.4816C5.63615 20.4816 5.15527 20.0007 5.15527 19.4075V17.0446Z",
    fill: "#2965FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6006 17.0446H13.7487V19.4075C13.7487 20.0007 13.2679 20.4816 12.6747 20.4816C12.0815 20.4816 11.6006 20.0007 11.6006 19.4075V17.0446Z",
    fill: "#2965FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofaActive);
export default __webpack_public_path__ + "static/media/sofa-active.55b18fdd76c02aaed925ef8cd400cc67.svg";
export { ForwardRef as ReactComponent };